import * as React from 'react';
import {ChangeEvent, useState} from "react";

interface CheckboxActionNonConformeProps {
  nonConforme: boolean
  onChangeNonConforme: (value: boolean) => void
}

export const CheckboxActionNonConforme = (props: CheckboxActionNonConformeProps) => {
  const [nonConforme, setNonConforme] = useState<boolean>(props.nonConforme);

  const strTitle = "Fichier non conforme";

  function onChangeNonConforme(event: ChangeEvent<HTMLInputElement>) {
      setNonConforme(event.target.checked);
      props.onChangeNonConforme(event.target.checked);
  }

  return (
      <div className={'d-flex align-items-center p-3 pt-0 pl-2 '}>
        <input type={'checkbox'} name={"fichierNonConforme"} checked={nonConforme} onChange={onChangeNonConforme}/>
        <label htmlFor="fichierNonConforme"
               className="m-0 nobold flex-grow-1 pl-2">
          {strTitle}
        </label>
      </div>
  );
}